import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TrustRequest } from "@fiduciaria/Shared/Types/request.interface";
import { Column } from "@universal-ui";

@Component({
  selector: "app-fiduciary-requests-table",
  templateUrl: "./fiduciary-requests-table.component.html",
})
export class FiduciaryRequestsTableComponent implements OnInit {
  public columns: Column[];
  @Input() public requests: TrustRequest[];
  @Input() public loading: boolean = false;

  @Output() public seeDetails = new EventEmitter<TrustRequest>();

  public action = [
    {
      icon: "eye",
      tooltip: "Ver más",
      name: "Detalles",
      click: (request: TrustRequest): void => this.seeDetails.emit(request),
    },
  ];

  public searchCols = [
   "createdBy",
   "date",
   "requestNumber",
   "type",
   "subType",
   "status",
   "subject"
  ];

  public ngOnInit(): void {
    this.columns = [
      {
        name: "Creado Por",
        prop: "createdBy",
        width: 150,
      },
      {
        name: "Fecha",
        prop: "date",
        width: 150,
      },
      {
        name: "Número Solicitud",
        prop: "requestNumber",
      },
      {
        name: "Tipo de Solicitud",
        prop: "type",
      },
      {
        name: "Subtipo de Solicitud",
        prop: "subType",
      },
      {
        name: "Estatus",
        prop: "status",
        width: 150,
      },
      {
        name: "Descripción",
        prop: "subject",
      }
    ];
  }
}
